let tabs = () => {
  $(document).on('click', '.js-tab', function () {
    let type = $(this).attr('data-type');
    let element = $('#domain' + type);
    let option = element.parents('.option');

    $('.js-tab').removeClass('active');
    $('.js-tab[data-type="' + type + '"]').addClass('active');
    $('.domain-selection-options .option').removeClass('option-selected');
    $('.domain-input-group').hide();

    option.addClass('option-selected');
    option.find('input[name="domainoption"]').prop('checked', true);
    element.show();
  });
};

let next = () => {
  $(document).on('click', '.js-button-continue', function () {
    $('#frmProductDomainSelections').submit();
  });
};

export default {
  init() {
    // JavaScript to be fired on all pages
    tabs();
    next();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/configureproductdomain.js